module.exports = __webpack_public_path__ + "media/images/talent/feature-image03-bcf6441aad458033334b49c7dd415b26.png";